// extracted by mini-css-extract-plugin
module.exports = {"spiner":"Spiner_spiner__3UfBT"};